import { createSelector } from '@ngrx/store';

import { getMemberState } from '../../../members/selectors/getMemberState';
import { getOrderSummary } from '../../../onlineOrder/selectors/getOrderSummary';

export const memberHasAvailableBalanceToPayForCartOrder = createSelector(getMemberState, getOrderSummary, (member, summary) => {
    if (!summary || !member.data || member.accountBalance.isDownloading === true || !member.accountBalance.data) return null;

    return summary.Total <= member.accountBalance.data?.AvailableBalance;
});
